import React from "react";
import "./pHStyles.css";

const ActivityLogSkeleton = () => {
  return (
    <div className='activity-skeleton'>
      {/* Activity Items */}
      <div className='activity-skeleton__list'>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
          <div key={index} className='activity-skeleton__group'>
            {/* Date Header */}
            {(index === 1 || index === 4 || index === 8) && <div className='activity-skeleton__date-header'></div>}

            {/* Activity Item */}
            <div className='activity-skeleton__item'>
              <div className='activity-skeleton__icon-container'>
                <div className={`activity-skeleton__icon activity-skeleton__icon--${getIconType(index)}`}></div>
              </div>

              <div className='activity-skeleton__content'>
                <div className='activity-skeleton__main-text'></div>
                <div className='activity-skeleton__sub-text'></div>
              </div>

              <div className='activity-skeleton__count'></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Helper function to vary icon types
const getIconType = (index) => {
  const types = ["sale", "edit", "discount", "damage", "return", "move"];
  return types[index % types.length];
};

export default ActivityLogSkeleton;
